import { LOG_SERVICE } from '@common/services/log/log.service.interface';
import { useTranslation } from '@scoring-web/configs/locale/locale.config';
import Dialog from '@ui/components/molecules/dialog/dialog.molecule';
import { useCallback, useEffect, useMemo } from 'react';
import { useRouteError } from 'react-router';
import { container } from 'tsyringe';

export default function MainErrorView() {
  // #region Dependencies
  const { t } = useTranslation();
  const error = useRouteError();
  // #endregion

  // #region Handlers
  const handleOnClose = useCallback(() => window.location.reload(), []);
  // #endregion

  // #region Computed Values
  const actions = useMemo(
    () => ({ label: t('label.yes'), onClick: handleOnClose }),
    [handleOnClose, t],
  );
  // #endregion

  // #region Effects
  useEffect(() => {
    if (
      !error ||
      (!(error instanceof Error) &&
        (typeof error !== 'object' || !('message' in error) || !('name' in error)))
    ) {
      return;
    }
    container
      .resolve(LOG_SERVICE)
      .captureError(error as Error, undefined, { source: 'main-error-view' });
  }, [error]);
  // #endregion

  return (
    <Dialog
      actions={actions}
      content={t('error.generic.description')}
      onClose={handleOnClose}
      open
    />
  );
}
